import React from 'react';

export default function Nothing() {
  return <div />;
}
